/* -------------------------------------------------------------------------------------------------
 *  BlueprintDetailsLoading
 * -----------------------------------------------------------------------------------------------*/

import { Skeleton } from '@rtkwlf/fenrir-react';

import { Stack } from '@packages/fenrir/components';

export const BlueprintDetailsLoading: React.FunctionComponent = () => {
  return (
    <Stack
      padding="var(--page-panel-padding)"
      height="100%"
      width="100%"
      direction="column"
      spacing={2}
      data-testid="blueprint-details-loading"
    >
      <Skeleton height="4rem" />
      <Skeleton height="2rem" />
      <Skeleton flex={1} />
    </Stack>
  );
};
